

































































































































































import Vue from 'vue';
import moment from 'moment';
import { ITipoLugar } from '../../interfaces/Zonas';
import config from '../../config/index';
import HandleErrors from '../../config/handleErrors';
import Confirmation from '../../components/Confirmation.vue';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import store from '@/store';
import { AxiosVue } from '@/AxiosVue';
import { EstadoEntidad, TipoLugarAlcance, ServicioProxy } from '@/config/enums';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Validator } from 'vee-validate';

const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    'ag-grid-vue': AgGridVue,
    'app-confirmacion': Confirmation,
  },
})
export default class TipolugarModalEdicion extends ComponenteBaseStepper {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: () => ({ id: 0, nombre: '' }) }) tiposlugar!: ITipoLugar;

  //permisos
  funcionalidad: Funcionalidades = Funcionalidades.GrupoDeZona;
  permisosActuales: PermisoAccionVm[] = [];

  informacionGeneral: PermisoAccionVm = {
    accion: 'Editar - Información General',
    visible: true,
    step: 1,
    codigoSubAccion: 19,
    codigoAccionPadre: CodigoAccion.Editar,
  };

  informacionGeneralVerDetalle: PermisoAccionVm = {
    accion: 'Ver Detalle - Información General',
    visible: true,
    step: 1,
    codigoSubAccion: 19,
    codigoAccionPadre: CodigoAccion.VerDetalle,
  };

  permisosTotales: PermisoAccionVm[] = [
    this.informacionGeneral,
    this.informacionGeneralVerDetalle,
  ];

  //Variables globales
  $snotify: any;
  btnText: string = 'Guardar';
  dialog: boolean = false;
  validForm: boolean = false;
  editedItem: ITipoLugar = {};
  dictionaryFormErrors: any = {};
  bottomNav: any = '1';
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;
  loadingService = new LoadingService();
  //SELECT--------------------------------------------------------------------------------------------

  handleErrors: HandleErrors = new HandleErrors();

  //grilla
  localeText: any = config.agGridTextos;
  gridApi: any;
  columnApi: any;
  gridApi2: any;
  columnApi2: any;
  sideBar: any = config.agGridDefaultConfig;
  autoGroupColumnDef: any = null;

  btnBloquear: Boolean = false;
  controller: string = 'grupodezona';
  controllerCliente: string = 'grupodeinteres';
  //CONTEXTOS INSTANCIAS ------------------------------------------------------------------------------------
  axContextoGps: AxiosVue = new AxiosVue(ServicioProxy.Gps);
  //---------------------------------------------------------------------------------------------------------
  //lOAD ---------------------------------------------------------------------------

  cerrarOperacion() {
    if (this.esEdicion) {
      this.dialogConfirmacionClose = true;
    } else {
      this.closeModal(false);
    }
  }
  initialize() {
    this.dictionaryFormErrors = {
      custom: {
        nombre: {
          required: () => config.errorMensajes.textoRequerido,
          GrupoZonaNombreUnicoEditar:
            '* Ya existe un Grupo de Zonas con este nombre.',
          max: config.errorMensajes.maxLength,
        },
        descripcion: {
          max: config.errorMensajes.maxLength,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }
  mounted() {
    this.initialize();
  }

  created() {
    this.registrarValidadores();
  }

  private registrarValidadores() {
    const self = this;
    const clienteId = config.getClienteSesion();

    Validator.extend('GrupoZonaNombreUnicoEditar', {
      getMessage(field: any, params: any, data: any) {
        return '* Ya existe un Grupo de Zonas con este nombre.';
      },
      validate(value: any) {
        if (value !== '') {
          return self.axContextoGps.http
            .get(
              `${self.controllerCliente}/${self.editedItem.id}/${clienteId}/${value}/ChequearNombreUnico`
            )
            .then(response => {
              return new Promise(resolve => {
                resolve({
                  valid: response.data,
                  data: response.data
                    ? undefined
                    : {
                        message:
                          '* Ya existe un Grupo de Zonas con este nombre.',
                      },
                });
              });
            })
            .catch(err => {
              return true;
            });
        } else {
          return true;
        }
      },
    });
  }

  //EVENTOS -----------------------------------------------------------------------
  @Watch('show')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    this.dialog = value;
    this.btnText = 'Guardar Cambios';
    this.bottomNav = '1';
    this.btnBloquear = false;

    // permisos
    this.chequearPermisosEditarDetalle();
    this.setBotonNav();

    let self = this;

    if (value == true) {
      this.loadingService.showLoading();
      this.axContextoGps.http
        .get<ITipoLugar>(`${this.controller}/${this.tiposlugar.id}`)
        .then(tipolugar => {
          self.editedItem = tipolugar.data;
          this.loadingService.hideLoading();
        })
        .catch(err => {
          this.loadingService.hideLoading();
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              this.handleErrors.showError(err);
            }
          } else {
            this.handleErrors.showError(err);
          }
        });
    }
  }

  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;
    if (!this.esEdicion) {
      accion = 'Ver Detalle';
    }
    this.permisosTotales.forEach(obj => {
      if (obj.visible && obj.accion.includes(accion) && !evaluado) {
        this.bottomNav = obj.step;
        evaluado = true;
      }
    });
  }

  //MODAL -------------------------------------------------------------------
  closeModal(val: boolean) {
    document.getElementById('cardDivRT').scrollIntoView(true);
    this.btnBloquear = false;
    this.editedItem = {};
    this.$emit('modalAsociacionEmit', false);
    this.dialog = false;
    this.$validator.errors.clear();
  }
  //-------------------------------------------------------------------------

  //GRID  -------------------------------------------------------------------
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  }

  //FUNCIONES ---------------------------------------------------------------
  formatDate(fecha: Date): string {
    if (!fecha) return null;
    return moment(fecha).format('DD/MM/YYYY');
  }

  fechaFilter(r: any) {
    return this.$options.filters.formatDate(r.value);
  }

  //MODIFICACION --------------------------------------------------------
  grabarEdicion() {
    this.$validator.validateAll().then(res => {
      if (res) {
        this.axContextoGps.http
          .get(this.controller)
          .then(res => {
            let tipos = res.data.filter(
              (x: any) =>
                x.nombre
                  .toString()
                  .toUpperCase()
                  .trim() ===
                  this.editedItem.nombre
                    .toString()
                    .toUpperCase()
                    .trim() &&
                x.estado !== EstadoEntidad.Eliminado &&
                x.id !== this.editedItem.id &&
                x.tipoLugarAlcance === TipoLugarAlcance.Cliente &&
                x.clienteId === this.getClienteID()
            );
            if (tipos.length === 0) {
              this.btnBloquear = true;
              this.dialogConfirmacion = true;
            } else {
              this.$snotify.error(
                'Ya existe un Grupo de Zonas con este nombre'
              );
            }
          })
          .catch(error => {
            this.btnBloquear = true;
            this.dialogConfirmacion = true;
          });
      }
    });
  }

  confirmCallback(val: boolean) {
    this.dialogConfirmacion = false;
    let he = new HandleErrors();
    if (val) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.btnBloquear = true;
          let boolError = this.actualizacionTipoLugar();
        }
      });
    }
    this.btnBloquear = false;
  }
  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  actualizacionTipoLugar(): boolean {
    this.loadingService.showLoading();
    let he = new HandleErrors();
    let boolError = false;
    let model = {
      Id: this.editedItem.id,
      nombre: this.editedItem.nombre,
      descripcion: this.editedItem.descripcion,
      clienteId: this.editedItem.clienteId,
      tipoLugarAlcance: TipoLugarAlcance.Cliente,
    };
    //Edición

    this.axContextoGps.http
      .put(`${this.controller}/`, model)
      .then(res => {
        this.close();
      })
      .catch(error => {
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.errorMSG(
              error,
              he,
              'Ha ocurrido un problema al intentar guardar los cambios'
            );
          }
        } else {
          this.errorMSG(
            error,
            he,
            'Ha ocurrido un problema al intentar guardar los cambios'
          );
        }
      });
    return boolError;
  }

  close() {
    this.loadingService.hideLoading();
    this.btnBloquear = false;
    this.closeModal(false);
    this.dialogConfirmacion = false;

    this.$snotify.success(this.$t('mensajes.mensajesExito.editar'));
  }

  //GET-------------------------------------------------------------------------------
  getClienteID() {
    return config.getClienteSesion();
  }

  errorMSG(error: any, he: HandleErrors, msg: string) {
    he.showError(error, msg);
    this.btnBloquear = false;
  }
}
